import { toast } from 'react-toastify';

type ToastFunction = (message: string, options?: object) => void;

const showSuccessMessage: ToastFunction = (message, options) => {
    toast.success(message, { pauseOnFocusLoss: false, ...options });
};

const showInfoMessage: ToastFunction = (message, options) => {
    toast.info(message, { pauseOnFocusLoss: false, ...options });
};

const showErrorMessage: ToastFunction = (message, options) => {
    toast.error(message, { pauseOnFocusLoss: false, ...options });
};

// Toast with options available on https://fkhadra.github.io/react-toastify/introduction/
const showToast = (
    toastFunction: ToastFunction,
    message: string,
    options?: object
): void => {
    toastFunction(message, { pauseOnFocusLoss: false, ...options });
};

export default {
    showSuccessMessage,
    showInfoMessage,
    showErrorMessage,
    showToast,
    toast,
};
